import React from "react";
import { withTranslation } from "react-i18next";
import { Badge, Progress } from "tabler-react";
import "./ClassCapacityDisplay.css";

function ClassCapacityDisplay({ t, scheduleClass, waitlistEnabled }) {
    const { spaces, countAttendingAndBooked, waitlistCount } = scheduleClass;

    if (!spaces) {
        return null;
    }

    // Calculate capacity percentage
    const capacityPercentage = Math.min(
        (countAttendingAndBooked / spaces) * 100,
        100,
    );

    return (
        <div className="class-capacity-display">
            <div className="capacity-info mb-2">
                <div className="capacity-numbers">
                    <strong>
                        {countAttendingAndBooked || 0}/{spaces}
                    </strong>{" "}
                </div>
                {waitlistEnabled && waitlistCount > 0 && (
                    <div className="waitlist-info mt-1">
                        <Badge color="warning" className="mr-1">
                            {waitlistCount}
                        </Badge>
                        <span className="text-muted">
                            {t("shop.classes.schedule.capacity.waitlist_count")}
                        </span>
                    </div>
                )}
            </div>

            <div className="capacity-progress">
                <Progress size="xs">
                    <Progress.Bar
                        color={
                            capacityPercentage >= 100
                                ? "danger"
                                : capacityPercentage >= 80
                                  ? "warning"
                                  : "success"
                        }
                        width={capacityPercentage}
                    />
                </Progress>

                {capacityPercentage >= 100 && (
                    <div className="mt-1">
                        <small className="text-danger">
                            {t("shop.classes.schedule.capacity.fully_booked")}
                        </small>
                    </div>
                )}
            </div>
        </div>
    );
}

export default withTranslation()(ClassCapacityDisplay);
